module.exports = __webpack_public_path__ + "static/media/arrow-0.dcec94e0.svg";